import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context } from '../../index';
import { observer } from 'mobx-react-lite';
import { SteamIcon } from '../Other/Icons';

function AccountTab () {
    const { t } = useTranslation();
    const {store} = useContext(Context);
    const totalBalance = store.user.balanceBonus + store.user.balanceDonate;
    const nickname = store.user.username;
    const avatar = store.user.avatar;
    
    if (!store.isLoaded) return <div className="auth_btn__EH3Sm loader-1 pointer-events-none"><span>LOG IN</span><span className="auth_logo__WWEvZ"><SteamIcon /></span></div>
    if (!store.isAuth) {
      return (
        <button className="auth_btn__EH3Sm" onClick={() => store.login()}>
            <span>{t('main.header.login')}</span>
            <span className="auth_logo__WWEvZ">
                <SteamIcon />
            </span>
        </button>
      )
    }
    else {
      return(
        <>
            <div className="account_account__D4+JF">
                <div className="account_depositWrapper__cKxIu">
                    <button className="account_depositBtn__6IZCa" onClick={e => {e.currentTarget.blur();store.setDonateModalOpen(true);}}>
                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" className="account_depositIcon__fQGY1"><path d="M13.6125 3.6208v3.4833h-1.375V3.6208c0-.2475-.22-.3666-.3666-.3666a.3675.3675 0 0 0-.1375.0274L4.4642 6.0225c-.4859.1833-.7975.6417-.7975 1.1642v.6141a3.4243 3.4243 0 0 0-1.375 2.75V7.1866c0-1.0908.6692-2.0625 1.6866-2.4474l7.2784-2.75a1.811 1.811 0 0 1 .6142-.11c.9166 0 1.7416.7424 1.7416 1.7416ZM19.7083 13.2917v.9167c0 .2475-.1925.4491-.4492.4583h-1.3383c-.4858 0-.9258-.3575-.9625-.8342-.0275-.2841.0825-.55.2658-.7333.165-.1742.3942-.2658.6417-.2658H19.25c.2658.0091.4583.2108.4583.4583Z" fill="#365230"></path><path d="M17.8567 11.8708h.935c.5042 0 .9167-.4125.9167-.9167v-.4033c0-1.8975-1.5492-3.4467-3.4467-3.4467H5.7383c-.7791 0-1.4941.2567-2.0716.6967a3.4244 3.4244 0 0 0-1.375 2.75V16.72c0 1.8975 1.5492 3.4466 3.4466 3.4466h10.5234c1.8975 0 3.4467-1.5491 3.4467-3.4466v-.1742c0-.5042-.4125-.9167-.9167-.9167h-.7975c-.88 0-1.7233-.5408-1.9525-1.3933-.1925-.6967.0367-1.3658.495-1.815.3392-.3483.8067-.55 1.32-.55Zm-5.0233-.1833H6.4167c-.3758 0-.6875-.3117-.6875-.6875 0-.3759.3117-.6875.6875-.6875h6.4167c.3758 0 .6875.3116.6875.6875 0 .3758-.3117.6875-.6875.6875Z" fill="#365230"></path></svg>
                    </button>
                </div>
                <Link to='/profile' className="account_link__5t-7i">
                    <div className="account_balance__f84Nc">
                        <div className="account_username__1">{nickname}</div>
                        <div className="account_balance">{new Intl.NumberFormat('ru-RU').format(Number(totalBalance?.toFixed(2)))} ₽</div>
                    </div>
                    <span className="account_photoWrapper__Xxp3z">
                        <img src={avatar} className="account_photo__PH-CP" alt=""/>
                    </span>
                </Link>
            </div>
        </>
      )
    }
}
export default observer(AccountTab);